export const renderLastMessage = (message, messageType) => {
    switch (messageType) {
        case 'text':
            return message || 'No message available';
        case 'image':
            return 'Image';
        case 'video':
            return 'Video';
        case 'file':
            return 'File';
        case 'audio':
            return 'Audio';
        case 'pic_request':
            return 'Pic Request';
        case 'call_request':
            return 'Call request';
        default:
            return 'Unsupported message type';
    }
};